export const FETCH_PLOT_STATE = "FETCH_PLOT_STATE";
// export const CLEAR_PLOT_STATE = "CLEAR_PLOT_STATE";
export const FETCH_PRODUCT_SITES_LIST = "FETCH_PRODUCT_SITES_LIST";
export const FETCH_PARAMETER_LIST = "FETCH_PARAMETER_LIST";
export const FETCH_FILTERED_BATCH_LIST = "FETCH_FILTERED_BATCH_LIST";
export const FETCH_SAVED_VIZ_LIST_REQUEST = "FETCH_SAVED_VIZ_LIST_REQUEST";
export const FETCH_FOLDER_REQUEST = "FETCH_FOLDER_REQUEST";
export const SAVE_VIZ_REQUEST = "SAVE_VIZ_REQUEST";
export const FETCH_SAVED_VIZ_DETAILS = "FETCH_SAVED_VIZ_DETAILS"
